interface Currency {
  shortName: string;
  longName: string;
  region: string;
  calendars?: string[];
}

export function sortCurrenciesByG7Order(currencies: Currency[]): Currency[] {
  const g7Currencies = ['USD', 'GBP', 'EUR', 'JPY', 'CAD'];

  // Sort the G7 currencies to the top of the list
  const sortedCurrencies = currencies.sort((a, b) => {
    if (
      g7Currencies.includes(a.shortName) &&
      g7Currencies.includes(b.shortName)
    ) {
      return (
        g7Currencies.indexOf(a.shortName) - g7Currencies.indexOf(b.shortName)
      );
    } else if (g7Currencies.includes(a.shortName)) {
      return -1;
    } else if (g7Currencies.includes(b.shortName)) {
      return 1;
    } else {
      return 0;
    }
  });

  return sortedCurrencies;
}
